<div class="flex flex-col p-0">
  @if (closeIcon) {
    <div [class]="headClass">
      <h2 class="text-[18px] font-bold leading-[normal] tracking-normal text-[#1c1c1c]">{{ title }}</h2>
      <button
        type="button"
        class="inline-flex shrink-0 items-center justify-center rounded-[6px] p-1.5 text-[#444] hover:bg-muted"
        [attr.aria-label]="closeText"
        [svcTestId]="testIdPrefix + '__btn--embed-dismiss'"
        (click)="close()"
      >
        <ng-icon
          name="svcX"
          size="14px"
          aria-hidden="true"
        />
      </button>
    </div>
  } @else {
    <h2 class="mb-2 text-[18px] font-bold leading-[normal] tracking-normal text-[#1c1c1c]">{{ title }}</h2>
  }

  <div [class]="bodyClass">
    <p [class]="descriptionClass">{{ description }}</p>

    <code
      [class]="codeClass"
      [svcTestId]="testIdPrefix + '__text--embed-code'"
    >{{ code }}</code>
  </div>

  <div [class]="actionsClass">
    <button
      type="button"
      z-button
      zType="outline-primary"
      [class]="actionButtonClass"
      [svcTestId]="testIdPrefix + '__btn--embed-close'"
      (click)="close()"
    >
      {{ closeText }}
    </button>
    <button
      type="button"
      z-button
      zType="default"
      [class]="actionButtonClass"
      [svcTestId]="testIdPrefix + '__btn--embed-copy'"
      (click)="copy()"
    >
      {{ copyText }}
    </button>
  </div>
</div>
